 export default function autofocus($timeout) {
  return {
    restrict: 'A',
    link : function($scope, $element) {
      $timeout(() => $element[0].focus(), 200);
    }
  };
 }



// WEBPACK FOOTER //
// ./src/login/autofocus.js